import React from "react"
import {
	IconCirclePlusOutline18 as PlusCircleIcon,
	IconTableOutline18 as Table,
	IconTrashOutline18 as TrashIcon,
} from "nucleo-ui-outline-18"

import type { Editor } from "@tiptap/react"
import { EditorMenuDropdown } from "./editor-menu-dropdown"

interface ListDropdownProps {
	editor: Editor
	containerRef?: React.RefObject<HTMLDivElement | null>
}

export const EditorMenuTableDropdown: React.FC<ListDropdownProps> = ({
	editor,
	containerRef,
}) => {
	const listTypes = [
		{ id: "table-add-column", label: "Add Column", icon: PlusCircleIcon },
		{ id: "table-add-row", label: "Add Row", icon: PlusCircleIcon },
		{ id: "table-remove-column", label: "Remove Column", icon: TrashIcon },
		{ id: "table-remove-row", label: "Remove Row", icon: TrashIcon },
		{ id: "table-remove-table", label: "Remove Table", icon: TrashIcon },
	]

	const onSelect = (id: string | number) => {
		const commandMap: Record<string, () => void> = {
			"table-add-column": () =>
				editor
					.chain()
					.focus(undefined, { scrollIntoView: false })
					.addColumnAfter()
					.run(),
			"table-add-row": () =>
				editor
					.chain()
					.focus(undefined, { scrollIntoView: false })
					.addRowAfter()
					.run(),
			"table-remove-column": () =>
				editor
					.chain()
					.focus(undefined, { scrollIntoView: false })
					.deleteColumn()
					.run(),
			"table-remove-row": () =>
				editor
					.chain()
					.focus(undefined, { scrollIntoView: false })
					.deleteRow()
					.run(),
			"table-remove-table": () =>
				editor
					.chain()
					.focus(undefined, { scrollIntoView: false })
					.deleteTable()
					.run(),
		}

		// Execute the corresponding command if it exists
		commandMap[id as string]?.()
	}

	const activeListType = listTypes.find(({ id }) => editor.isActive(id))?.id

	return (
		<EditorMenuDropdown
			containerRef={containerRef}
			items={listTypes}
			activeItem={activeListType}
			onSelect={onSelect}
			triggerIcon={Table}
		/>
	)
}
